import { useEffect, useState } from 'react';
import styles from './OptionCard.module.scss';

const OptionCard = ({
  icon,
  title = '',
  description = '',
  btnText = '',
  onClickHandler = () => {},
}) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const enterKeyHandler = (e) => {
    if (e.key == 'Enter') {
      onClickHandler(event);
    }
  };

  return (
    <div
      className={styles.optionCardContainer}
      onClick={onClickHandler}
      tabIndex={0}
      onKeyDown={enterKeyHandler}
    >
      <div className={styles.optionCardInfo}>
        <div className={styles.optionCardIconContainer}>{mounted && icon}</div>
        <h4>{title}</h4>
        <p>{description}</p>
      </div>
      <div className={styles.optionCardButton}>
        <div>{btnText}</div>
      </div>
    </div>
  );
};

export default OptionCard;
